import { LicenseService } from '../../sdk/licenseService';
import { computeLicenseStatus, getEffectiveLimit, isWidgetAllowed } from '../../utils/licenseUtils';

// ─── Thunks ───────────────────────────────────────────────────────────────────

export const fetchLicense = (organizationId) => async (dispatch) => {
  dispatch({ type: 'FETCH_LICENSE_START' });
  try {
    const raw = await LicenseService.getLicense(organizationId);
    const license = raw ? computeLicenseStatus(raw) : null;
    dispatch({ type: 'FETCH_LICENSE_SUCCESS', payload: license });
  } catch (error) {
    console.error('Error fetching license:', error);
    dispatch({ type: 'FETCH_LICENSE_FAILURE', payload: 'Failed to load license' });
  }
};

export const fetchPlanDefinitions = () => async (dispatch) => {
  try {
    const defs = await LicenseService.getAllPlanDefinitions();
    dispatch({ type: 'FETCH_PLAN_DEFINITIONS_SUCCESS', payload: defs });
  } catch (error) {
    console.error('Error fetching plan definitions:', error);
  }
};

export const fetchActivePromotion = () => async (dispatch) => {
  try {
    const promo = await LicenseService.getActivePromotion();
    dispatch({ type: 'FETCH_PROMOTION_SUCCESS', payload: promo });
  } catch (error) {
    console.error('Error fetching promotion:', error);
  }
};

export const fetchAdminUids = () => async (dispatch) => {
  try {
    const uids = await LicenseService.getAdminUids();
    dispatch({ type: 'FETCH_ADMIN_UIDS_SUCCESS', payload: uids });
  } catch (error) {
    console.error('Error fetching admin UIDs:', error);
  }
};

// ─── Selectors ────────────────────────────────────────────────────────────────

export const selectLicense = (state) => state.license.license;
export const selectPlanDefinitions = (state) => state.license.planDefinitions;
export const selectActivePromotion = (state) => state.license.activePromotion;
export const selectAdminUids = (state) => state.license.adminUids;

export const selectActivePlanConfig = (state) => {
  const license = selectLicense(state);
  const defs = selectPlanDefinitions(state);
  if (!license || !defs) return null;
  return defs[license.plan] || null;
};

export const selectEffectiveLimit = (state, limitKey) => {
  const license = selectLicense(state);
  const planConfig = selectActivePlanConfig(state);
  return getEffectiveLimit(planConfig, license, limitKey);
};

export const selectIsWidgetAllowed = (state, widget) => {
  const license = selectLicense(state);
  const defs = selectPlanDefinitions(state);
  return isWidgetAllowed(defs, license, widget);
};

export const selectIsLicenseExpired = (state) => {
  return selectLicense(state)?.isExpired ?? false;
};

export const selectDaysRemainingInTrial = (state) => {
  return selectLicense(state)?.daysRemainingInTrial ?? null;
};

export const selectIsCurrentUserAdmin = (state) => {
  const uid = state.auth?.user?.userId;
  const adminUids = selectAdminUids(state);
  return uid ? adminUids.includes(uid) : false;
};
